// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 576px) {

  .container {
    max-width: 576px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
  }
}
@media (min-width: 1200px) {

  .container {
    max-width: 1200px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 1700px) {

  .container {
    max-width: 1700px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-full {
  inset: 100%;
}
.m-0 {
  margin: 0px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.5rem;
}
.mb-6 {
  margin-bottom: 2rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-12 {
  margin-top: 5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.5rem;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.5rem;
}
.w-4 {
  width: 1rem;
}
.w-8 {
  width: 3rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1 0%;
}
.cursor-pointer {
  cursor: pointer;
}
.select-all {
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.overflow-hidden {
  overflow: hidden;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-neutral-200), var(--tw-border-opacity));
}
.border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-neutral-300), var(--tw-border-opacity));
}
.border-t-neutral-200 {
  --tw-border-opacity: 1;
  border-top-color: rgba(var(--hc-color-neutral-200), var(--tw-border-opacity));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--hc-color-neutral-100), var(--tw-bg-opacity));
}
.bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--hc-color-neutral-200), var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.p-1 {
  padding: 0.25rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-6 {
  padding-bottom: 2rem;
}
.text-center {
  text-align: center;
}
.text-3extralarge {
  font-size: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.capitalize {
  text-transform: capitalize;
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgba(var(--hc-color-neutral-500), var(--tw-text-opacity));
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgba(var(--hc-color-neutral-600), var(--tw-text-opacity));
}
.text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgba(var(--hc-color-neutral-900), var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.accent-neutral-900 {
  accent-color: rgb(var(--hc-color-neutral-900));
}
.opacity-0 {
  opacity: 0;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

:root {
  /* Primary RGBs*/
  --hc-color-primary-100: 158, 164, 172;
  --hc-color-primary-200: 112, 119, 128;
  --hc-color-primary-300: 70, 75, 82;
  --hc-color-primary-400: 50, 54, 59;
  --hc-color-primary-500: 40, 44, 47;
  --hc-color-primary-600: 25, 28, 31;
  --hc-color-primary-700: 0, 0, 0;
  /* Secondary RGBs*/
  --hc-color-secondary-100: 237, 255, 255;
  --hc-color-secondary-200: 162, 234, 234;
  --hc-color-secondary-300: 124, 219, 219;
  --hc-color-secondary-400: 81, 193, 195;
  --hc-color-secondary-500: 10, 144, 144;
  --hc-color-secondary-600: 6, 98, 98;
  --hc-color-secondary-700: 2, 66, 66;
  /* Success RGBs*/
  --hc-color-success-100: 237, 255, 245;
  --hc-color-success-200: 153, 233, 187;
  --hc-color-success-300: 74, 204, 130;
  --hc-color-success-400: 0, 157, 67;
  --hc-color-success-500: 0, 110, 47;
  --hc-color-success-600: 0, 81, 34;
  --hc-color-success-700: 0, 52, 22;
  /* Warning RGBs*/
  --hc-color-warning-100: 255, 250, 235;
  --hc-color-warning-200: 249, 226, 152;
  --hc-color-warning-300: 251, 212, 88;
  --hc-color-warning-400: 239, 186, 15;
  --hc-color-warning-500: 164, 124, 0;
  --hc-color-warning-600: 108, 82, 0;
  --hc-color-warning-700: 69, 52, 0;
  /* Danger RGBs*/
  --hc-color-danger-100: 255, 240, 240;
  --hc-color-danger-200: 249, 202, 200;
  --hc-color-danger-300: 227, 117, 112;
  --hc-color-danger-400: 214, 52, 44;
  --hc-color-danger-500: 168, 26, 10;
  --hc-color-danger-600: 131, 13, 0;
  --hc-color-danger-700: 89, 9, 0;
  /* Info RGBs*/
  --hc-color-info-100: 240, 244, 255;
  --hc-color-info-200: 190, 209, 255;
  --hc-color-info-300: 137, 168, 248;
  --hc-color-info-400: 89, 129, 227;
  --hc-color-info-500: 53, 92, 192;
  --hc-color-info-600: 37, 63, 130;
  --hc-color-info-700: 22, 44, 100;
  /* Andromeda RGBs*/
  --hc-color-andromeda-100: 246, 242, 255;
  --hc-color-andromeda-200: 211, 198, 253;
  --hc-color-andromeda-300: 172, 147, 252;
  --hc-color-andromeda-400: 124, 94, 226;
  --hc-color-andromeda-500: 90, 56, 198;
  --hc-color-andromeda-600: 71, 39, 176;
  --hc-color-andromeda-700: 38, 10, 129;
  /* Sirius RGBs*/
  --hc-color-sirius-100: 255, 246, 254;
  --hc-color-sirius-200: 255, 184, 248;
  --hc-color-sirius-300: 248, 153, 238;
  --hc-color-sirius-400: 228, 114, 217;
  --hc-color-sirius-500: 184, 50, 171;
  --hc-color-sirius-600: 126, 34, 116;
  --hc-color-sirius-700: 85, 21, 79;
  /* Neutral RGBs*/
  --hc-color-neutral-0: 255, 255, 255;
  --hc-color-neutral-100: 247, 249, 250;
  --hc-color-neutral-200: 230, 233, 237;
  --hc-color-neutral-300: 201, 206, 212;
  --hc-color-neutral-400: 158, 164, 172;
  --hc-color-neutral-500: 112, 119, 128;
  --hc-color-neutral-600: 70, 75, 82;
  --hc-color-neutral-700: 50, 54, 59;
  --hc-color-neutral-800: 40, 44, 47;
  --hc-color-neutral-900: 25, 28, 31;
  --hc-color-neutral-1000: 0, 0, 0;
}

.dark {
  /* Primary RGBs*/
  --hc-color-primary-100: 0, 0, 0;
  --hc-color-primary-200: 25, 28, 31;
  --hc-color-primary-300: 40, 44, 47;
  --hc-color-primary-400: 50, 54, 59;
  --hc-color-primary-500: 230, 233, 237;
  --hc-color-primary-600: 247, 249, 250;
  --hc-color-primary-700: 255, 255, 255;
  /* Secondary RGBs*/
  --hc-color-secondary-100: 2, 66, 66;
  --hc-color-secondary-200: 6, 98, 98;
  --hc-color-secondary-300: 10, 144, 144;
  --hc-color-secondary-400: 81, 193, 195;
  --hc-color-secondary-500: 124, 219, 219;
  --hc-color-secondary-600: 162, 234, 234;
  --hc-color-secondary-700: 237, 255, 255;
  /* Success RGBs*/
  --hc-color-success-100: 0, 52, 22;
  --hc-color-success-200: 0, 81, 34;
  --hc-color-success-300: 0, 110, 47;
  --hc-color-success-400: 0, 157, 67;
  --hc-color-success-500: 74, 204, 130;
  --hc-color-success-600: 153, 233, 187;
  --hc-color-success-700: 237, 255, 245;
  /* Warning RGBs*/
  --hc-color-warning-100: 69, 52, 0;
  --hc-color-warning-200: 108, 82, 0;
  --hc-color-warning-300: 164, 124, 0;
  --hc-color-warning-400: 239, 186, 15;
  --hc-color-warning-500: 251, 212, 88;
  --hc-color-warning-600: 249, 226, 152;
  --hc-color-warning-700: 255, 250, 235;
  /* Danger RGBs*/
  --hc-color-danger-100: 89, 9, 0;
  --hc-color-danger-200: 131, 13, 0;
  --hc-color-danger-300: 168, 26, 10;
  --hc-color-danger-400: 214, 52, 44;
  --hc-color-danger-500: 227, 117, 112;
  --hc-color-danger-600: 249, 202, 200;
  --hc-color-danger-700: 255, 240, 240;
  /* Info RGBs*/
  --hc-color-info-100: 22, 44, 100;
  --hc-color-info-200: 37, 63, 130;
  --hc-color-info-300: 53, 92, 192;
  --hc-color-info-400: 89, 129, 227;
  --hc-color-info-500: 137, 168, 248;
  --hc-color-info-600: 190, 209, 255;
  --hc-color-info-700: 240, 244, 255;
  /* Andromeda RGBs*/
  --hc-color-andromeda-100: 38, 10, 129;
  --hc-color-andromeda-200: 71, 39, 176;
  --hc-color-andromeda-300: 90, 56, 198;
  --hc-color-andromeda-400: 124, 94, 226;
  --hc-color-andromeda-500: 172, 147, 252;
  --hc-color-andromeda-600: 211, 198, 253;
  --hc-color-andromeda-700: 246, 242, 255;
  /* Sirius RGBs*/
  --hc-color-sirius-100: 85, 21, 79;
  --hc-color-sirius-200: 126, 34, 116;
  --hc-color-sirius-300: 184, 50, 171;
  --hc-color-sirius-400: 228, 114, 217;
  --hc-color-sirius-500: 248, 153, 238;
  --hc-color-sirius-600: 255, 184, 248;
  --hc-color-sirius-700: 255, 246, 254;
  /* Neutral RGBs*/
  --hc-color-neutral-0: 0, 0, 0;
  --hc-color-neutral-100: 25, 28, 31;
  --hc-color-neutral-200: 40, 44, 47;
  --hc-color-neutral-300: 50, 54, 59;
  --hc-color-neutral-400: 70, 75, 82;
  --hc-color-neutral-500: 112, 119, 128;
  --hc-color-neutral-600: 158, 164, 172;
  --hc-color-neutral-700: 201, 206, 212;
  --hc-color-neutral-800: 230, 233, 237;
  --hc-color-neutral-900: 247, 249, 250;
  --hc-color-neutral-1000: 255, 255, 255;
}

body {
  overflow-y: auto;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-x-0::after {
  content: var(--tw-content);
  left: 0px;
  right: 0px;
}

.after\\:top-1\\/2::after {
  content: var(--tw-content);
  top: 50%;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.5rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:-translate-y-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-info-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-info-200), var(--tw-border-opacity));
}

.after\\:border-neutral-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-neutral-200), var(--tw-border-opacity));
}

.after\\:bg-info-400::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgba(var(--hc-color-info-400), var(--tw-bg-opacity));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-neutral-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(var(--hc-color-neutral-100), var(--tw-ring-opacity));
}

.focus-visible\\:ring-info-200:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(var(--hc-color-info-200), var(--tw-ring-opacity));
}

.peer:checked ~ .peer-checked\\:bg-info-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--hc-color-info-200), var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-info-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-info-200), var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:after\\:border-neutral-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(var(--hc-color-neutral-200), var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:ring-info-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(var(--hc-color-info-200), var(--tw-ring-opacity));
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gBAA0B,EAA1B,MAA0B;EAA1B,cAA0B;KAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;KAA/B,qBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;;AAE/B;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,sCAAsC;EACtC,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,aAAa;EACb,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,eAAe;EACf,iCAAiC;EACjC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AApKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,SAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,kBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,wBAqKA;EArKA,wDAqKA;EArKA;AAqKA;;AArKA;EAAA,gBAqKA;EArKA;AAqKA;;AArKA;EAAA,8BAqKA;EArKA;AAqKA;;AArKA;EAAA,2GAqKA;EArKA,yGAqKA;EArKA;AAqKA;;AArKA;EAAA,oBAqKA;EArKA;AAqKA;;AArKA;EAAA,oBAqKA;EArKA;AAqKA;;AArKA;EAAA,kBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA,oBAqKA;EArKA;AAqKA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n:root {\n  /* Primary RGBs*/\n  --hc-color-primary-100: 158, 164, 172;\n  --hc-color-primary-200: 112, 119, 128;\n  --hc-color-primary-300: 70, 75, 82;\n  --hc-color-primary-400: 50, 54, 59;\n  --hc-color-primary-500: 40, 44, 47;\n  --hc-color-primary-600: 25, 28, 31;\n  --hc-color-primary-700: 0, 0, 0;\n  /* Secondary RGBs*/\n  --hc-color-secondary-100: 237, 255, 255;\n  --hc-color-secondary-200: 162, 234, 234;\n  --hc-color-secondary-300: 124, 219, 219;\n  --hc-color-secondary-400: 81, 193, 195;\n  --hc-color-secondary-500: 10, 144, 144;\n  --hc-color-secondary-600: 6, 98, 98;\n  --hc-color-secondary-700: 2, 66, 66;\n  /* Success RGBs*/\n  --hc-color-success-100: 237, 255, 245;\n  --hc-color-success-200: 153, 233, 187;\n  --hc-color-success-300: 74, 204, 130;\n  --hc-color-success-400: 0, 157, 67;\n  --hc-color-success-500: 0, 110, 47;\n  --hc-color-success-600: 0, 81, 34;\n  --hc-color-success-700: 0, 52, 22;\n  /* Warning RGBs*/\n  --hc-color-warning-100: 255, 250, 235;\n  --hc-color-warning-200: 249, 226, 152;\n  --hc-color-warning-300: 251, 212, 88;\n  --hc-color-warning-400: 239, 186, 15;\n  --hc-color-warning-500: 164, 124, 0;\n  --hc-color-warning-600: 108, 82, 0;\n  --hc-color-warning-700: 69, 52, 0;\n  /* Danger RGBs*/\n  --hc-color-danger-100: 255, 240, 240;\n  --hc-color-danger-200: 249, 202, 200;\n  --hc-color-danger-300: 227, 117, 112;\n  --hc-color-danger-400: 214, 52, 44;\n  --hc-color-danger-500: 168, 26, 10;\n  --hc-color-danger-600: 131, 13, 0;\n  --hc-color-danger-700: 89, 9, 0;\n  /* Info RGBs*/\n  --hc-color-info-100: 240, 244, 255;\n  --hc-color-info-200: 190, 209, 255;\n  --hc-color-info-300: 137, 168, 248;\n  --hc-color-info-400: 89, 129, 227;\n  --hc-color-info-500: 53, 92, 192;\n  --hc-color-info-600: 37, 63, 130;\n  --hc-color-info-700: 22, 44, 100;\n  /* Andromeda RGBs*/\n  --hc-color-andromeda-100: 246, 242, 255;\n  --hc-color-andromeda-200: 211, 198, 253;\n  --hc-color-andromeda-300: 172, 147, 252;\n  --hc-color-andromeda-400: 124, 94, 226;\n  --hc-color-andromeda-500: 90, 56, 198;\n  --hc-color-andromeda-600: 71, 39, 176;\n  --hc-color-andromeda-700: 38, 10, 129;\n  /* Sirius RGBs*/\n  --hc-color-sirius-100: 255, 246, 254;\n  --hc-color-sirius-200: 255, 184, 248;\n  --hc-color-sirius-300: 248, 153, 238;\n  --hc-color-sirius-400: 228, 114, 217;\n  --hc-color-sirius-500: 184, 50, 171;\n  --hc-color-sirius-600: 126, 34, 116;\n  --hc-color-sirius-700: 85, 21, 79;\n  /* Neutral RGBs*/\n  --hc-color-neutral-0: 255, 255, 255;\n  --hc-color-neutral-100: 247, 249, 250;\n  --hc-color-neutral-200: 230, 233, 237;\n  --hc-color-neutral-300: 201, 206, 212;\n  --hc-color-neutral-400: 158, 164, 172;\n  --hc-color-neutral-500: 112, 119, 128;\n  --hc-color-neutral-600: 70, 75, 82;\n  --hc-color-neutral-700: 50, 54, 59;\n  --hc-color-neutral-800: 40, 44, 47;\n  --hc-color-neutral-900: 25, 28, 31;\n  --hc-color-neutral-1000: 0, 0, 0;\n}\n\n.dark {\n  /* Primary RGBs*/\n  --hc-color-primary-100: 0, 0, 0;\n  --hc-color-primary-200: 25, 28, 31;\n  --hc-color-primary-300: 40, 44, 47;\n  --hc-color-primary-400: 50, 54, 59;\n  --hc-color-primary-500: 230, 233, 237;\n  --hc-color-primary-600: 247, 249, 250;\n  --hc-color-primary-700: 255, 255, 255;\n  /* Secondary RGBs*/\n  --hc-color-secondary-100: 2, 66, 66;\n  --hc-color-secondary-200: 6, 98, 98;\n  --hc-color-secondary-300: 10, 144, 144;\n  --hc-color-secondary-400: 81, 193, 195;\n  --hc-color-secondary-500: 124, 219, 219;\n  --hc-color-secondary-600: 162, 234, 234;\n  --hc-color-secondary-700: 237, 255, 255;\n  /* Success RGBs*/\n  --hc-color-success-100: 0, 52, 22;\n  --hc-color-success-200: 0, 81, 34;\n  --hc-color-success-300: 0, 110, 47;\n  --hc-color-success-400: 0, 157, 67;\n  --hc-color-success-500: 74, 204, 130;\n  --hc-color-success-600: 153, 233, 187;\n  --hc-color-success-700: 237, 255, 245;\n  /* Warning RGBs*/\n  --hc-color-warning-100: 69, 52, 0;\n  --hc-color-warning-200: 108, 82, 0;\n  --hc-color-warning-300: 164, 124, 0;\n  --hc-color-warning-400: 239, 186, 15;\n  --hc-color-warning-500: 251, 212, 88;\n  --hc-color-warning-600: 249, 226, 152;\n  --hc-color-warning-700: 255, 250, 235;\n  /* Danger RGBs*/\n  --hc-color-danger-100: 89, 9, 0;\n  --hc-color-danger-200: 131, 13, 0;\n  --hc-color-danger-300: 168, 26, 10;\n  --hc-color-danger-400: 214, 52, 44;\n  --hc-color-danger-500: 227, 117, 112;\n  --hc-color-danger-600: 249, 202, 200;\n  --hc-color-danger-700: 255, 240, 240;\n  /* Info RGBs*/\n  --hc-color-info-100: 22, 44, 100;\n  --hc-color-info-200: 37, 63, 130;\n  --hc-color-info-300: 53, 92, 192;\n  --hc-color-info-400: 89, 129, 227;\n  --hc-color-info-500: 137, 168, 248;\n  --hc-color-info-600: 190, 209, 255;\n  --hc-color-info-700: 240, 244, 255;\n  /* Andromeda RGBs*/\n  --hc-color-andromeda-100: 38, 10, 129;\n  --hc-color-andromeda-200: 71, 39, 176;\n  --hc-color-andromeda-300: 90, 56, 198;\n  --hc-color-andromeda-400: 124, 94, 226;\n  --hc-color-andromeda-500: 172, 147, 252;\n  --hc-color-andromeda-600: 211, 198, 253;\n  --hc-color-andromeda-700: 246, 242, 255;\n  /* Sirius RGBs*/\n  --hc-color-sirius-100: 85, 21, 79;\n  --hc-color-sirius-200: 126, 34, 116;\n  --hc-color-sirius-300: 184, 50, 171;\n  --hc-color-sirius-400: 228, 114, 217;\n  --hc-color-sirius-500: 248, 153, 238;\n  --hc-color-sirius-600: 255, 184, 248;\n  --hc-color-sirius-700: 255, 246, 254;\n  /* Neutral RGBs*/\n  --hc-color-neutral-0: 0, 0, 0;\n  --hc-color-neutral-100: 25, 28, 31;\n  --hc-color-neutral-200: 40, 44, 47;\n  --hc-color-neutral-300: 50, 54, 59;\n  --hc-color-neutral-400: 70, 75, 82;\n  --hc-color-neutral-500: 112, 119, 128;\n  --hc-color-neutral-600: 158, 164, 172;\n  --hc-color-neutral-700: 201, 206, 212;\n  --hc-color-neutral-800: 230, 233, 237;\n  --hc-color-neutral-900: 247, 249, 250;\n  --hc-color-neutral-1000: 255, 255, 255;\n}\n\nbody {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
